module.exports = __webpack_public_path__ + "img/signup-guide-05-06.a6489616.png";